export const getFriendlyErrorMessage = (error: any, defaultMessage: string): string => {
  if (error?.response?.status === 409) {
    return error.response.data?.message || 'Data ini sudah diproses oleh pengguna lain. Silakan segarkan halaman.';
  }
  
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }

  return defaultMessage;
};
